export default "__VITE_ASSET__C$J1FJBw__"